<div class="container pt-3 pb-3">
  <rbb-side-menu-headline [headline]="id === 'new' ? 'Neue Formulargruppe' : 'Formulargruppe bearbeiten'" icon="fas fa-copy"/>
  @if (formGroup) {
    <div class="row">
      <div class="col-6">
        <div class="form-group mb-3">
          <label for="name">Anzeigename <sup class="text-primary">*</sup></label>
          <input type="text" class="form-control form-control-sm" id="name" name="name" [(ngModel)]="formGroup.name" (change)="createTag()">
        </div>
      </div>
      <div class="col-6">
        <div class="form-group mb-3">
          <label for="name">Tag <sup class="text-primary">*</sup></label>
          <input type="text" [disabled]="id !== 'new'" class="form-control form-control-sm" id="tag" name="tag" [(ngModel)]="formGroup.tag">
          <span class="small text-secondary d-block mb-3 description-badge"><i class="fas fa-arrow-right"></i>&ensp;{{webUrl}}/group-tag/{{formGroup.tag}}</span>
        </div>
      </div>
      <div class="col-6 d-flex">
        <div class="form-group mt-4">
          <div class="form-check form-switch mb-3">
            <input type="checkbox" class="form-check-input" id="hide" name="hide" [(ngModel)]="formGroup.hide">
            <label class="form-check-label" for="hide">Formulargruppe verstecken / deaktivieren</label>
          </div>
        </div>
      </div>
      <div class="col-6">
        <div class="form-group mb-3">
          <label>Verantwortliche <sup class="text-primary">*</sup></label>
          <rbb-people-picker [(ngModel)]="owners" (ngModelChange)="ownersChanged()" size="sm"/>
          <span class="small text-secondary d-block mb-3 description-badge"><i class="fas fa-info"></i>&ensp;Können diese Formulargruppe verändern.</span>
        </div>
      </div>
      <div class="col-12 mb-4">
        <div class="form-group mb-3">
          <label for="description">Beschreibung <sup class="text-primary">*</sup></label>
          <textarea class="form-control form-control-sm" id="description" name="description" [(ngModel)]="formGroup.description" rows="10"></textarea>
          <span class="small text-secondary d-block mb-3 description-badge"><i class="fas fa-info"></i>&ensp;Beschreibung der Formulare und Frage zum Auswählen der Formulare.</span>
        </div>
      </div>
      <div class="col-12 mb-4">
        Auswahloptionen für rbb Forms
        @for (key of optionKeys; let i = $index; track i) {
          <div class="row mb-3">
            <div class="col">
              <select class="form-select form-select-sm" id="optionKey{{i}}" name="optionKey{{i}}" [(ngModel)]="optionKeys[i]">
                @for (form of forms; track form.id) {
                  <option [value]="form.tag">{{form.name}}</option>
                }
              </select>
            </div>
            <div class="col">
              <input type="text" id="optionValue{{i}}" name="optionValue{{i}}" class="form-control form-control-sm" [(ngModel)]="optionValues[i]" placeholder="Auswahlantwort">
            </div>
            <div class="col-auto fas-arrow-width">
              @if (i) {<i class="d-inline-block far fa-caret-square-up align-middle pointer transform grow-effect"
                          (click)="orderOption(i, i - 1)" (keydown.enter)="orderOption(i, i - 1)" (keydown.space)="orderOption(i, i - 1)" tabindex="0"></i>}
            </div>
            <div class="col-auto fas-arrow-width">
              @if (i < optionKeys.length - 1) {<i class="d-inline-block far fa-caret-square-down align-middle pointer transform grow-effect"
                                                  (click)="orderOption(i, i + 1)" (keydown.enter)="orderOption(i, i + 1)" (keydown.space)="orderOption(i, i + 1)" tabindex="0"></i>}
            </div>
            <div class="col-auto">
              <i class="d-inline-block fas fa-times text-danger pointer align-middle transform grow-effect"
                 (click)="removeSpecificOption(i)" (keydown.enter)="removeSpecificOption(i)" (keydown.space)="removeSpecificOption(i)" tabindex="0"></i>
            </div>
          </div>
        }
        <div class="row">
          <div class="col">
            <hr class="m-0 p-0 hr-custom">
          </div>
          <div class="col-auto">
            <button type="button" class="btn btn-sm btn-outline-success me-2" (click)="addOption()" aria-label="Option hinzufügen"><i class="fas fa-plus" aria-hidden="true"></i></button>
            <button type="button" class="btn btn-sm btn-outline-danger" (click)="removeOption()" aria-label="Option entfernen"><i class="fas fa-minus" aria-hidden="true"></i></button>
          </div>
          <div class="col">
            <hr class="m-0 p-0 hr-custom">
          </div>
        </div>
      </div>
      <div class="col-12">
        Auswahloptionen für andere Formulare (Links)
        @for (key of linkKeys; let i = $index; track i) {
          <div class="row mb-3">
            <div class="col">
              <input type="text" id="linkKey{{i}}" name="linkKey{{i}}" class="form-control form-control-sm" [(ngModel)]="linkKeys[i]" placeholder="Link">
            </div>
            <div class="col">
              <input type="text" id="linkValue{{i}}" name="linkValue{{i}}" class="form-control form-control-sm" [(ngModel)]="linkValues[i]" placeholder="Auswahlantwort">
            </div>
            <div class="col-auto fas-arrow-width">
              @if (i) {<i class="d-inline-block far fa-caret-square-up align-middle pointer transform grow-effect"
                          (click)="orderLink(i, i - 1)" (keydown.enter)="orderLink(i, i - 1)" (keydown.space)="orderLink(i, i - 1)" tabindex="0"></i>}
            </div>
            <div class="col-auto fas-arrow-width">
              @if (i < linkKeys.length - 1) {<i class="d-inline-block far fa-caret-square-down align-middle pointer transform grow-effect"
                                                (click)="orderLink(i, i + 1)" (keydown.enter)="orderLink(i, i + 1)" (keydown.space)="orderLink(i, i + 1)" tabindex="0"></i>}
            </div>
            <div class="col-auto">
              <i class="d-inline-block fas fa-times text-danger pointer align-middle transform grow-effect"
                 (click)="removeSpecificLink(i)" (keydown.enter)="removeSpecificLink(i)" (keydown.space)="removeSpecificLink(i)" tabindex="0"></i>
            </div>
          </div>
        }
        <div class="row">
          <div class="col">
            <hr class="m-0 p-0 hr-custom">
          </div>
          <div class="col-auto">
            <button type="button" class="btn btn-sm btn-outline-success me-2" (click)="addLink()" aria-label="Option hinzufügen"><i class="fas fa-plus" aria-hidden="true"></i></button>
            <button type="button" class="btn btn-sm btn-outline-danger" (click)="removeLink()" aria-label="Option entfernen"><i class="fas fa-minus" aria-hidden="true"></i></button>
          </div>
          <div class="col">
            <hr class="m-0 p-0 hr-custom">
          </div>
        </div>
      </div>
      <div class="col-12 mt-5 text-end">
        <button class="btn btn-danger me-2" routerLink="/form-groups"><i class="fas fa-times" aria-hidden="true"></i>&ensp;Abbrechen</button>
        <button class="btn btn-success" (click)="saveFormGroup()"><i class="fas fa-save" aria-hidden="true"></i>&ensp;Speichern</button>
      </div>
    </div>
  }
</div>
